const axios = require("axios")

export const blogpostEventHandler = async ({ email, blogpost }) => {
  try {
    const response = await axios.post(
      `https://ciobackend.zerotomastery.io/api/v1/website-signups/blogposts`,
      {
        email,
        blogpost,
      }
    )

    return response
  } catch (error) {
    return {
      status: error?.response?.status || 500,
      message: error?.response?.statusText || "An error occurred",
    }
  }
}
